import { FCX } from "@datassential/platform-ui-lib";
import { memo } from "react";
import { HomeShow } from "@core/constants";
import TableViewRawNorm from "@pages/Home/components/TableView/TableViewRawNorm";
import TableViewIndex from "@pages/Home/components/TableView/TableViewIndex";
import useQueryState from "@hooks/useQueryState";

const TableView: FCX = () => {
    const [show, setShow] = useQueryState<HomeShow>('show', HomeShow.Raw);

    return (
        <>
            {show !== HomeShow.Index && <TableViewRawNorm show={show} setShow={setShow}/>}
            {show === HomeShow.Index && <TableViewIndex show={show} setShow={setShow}/>}
        </>
    )
};

export default memo(TableView);